import React from 'react';
import logo from '../../../assets/logo.png';

export const MONTHS = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function numberToWords(amount) {
  const num = Math.floor(Number(amount) || 0);
  const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  if (num === 0) return 'Zero Rupees Only';
  if (num.toString().length > 9) return 'Amount too large';
  const n = (`000000000${num}`).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return '';
  let str = '';
  str += n[1] !== '00' ? `${a[Number(n[1])] || `${b[n[1][0]]} ${a[n[1][1]]}`} Crore ` : '';
  str += n[2] !== '00' ? `${a[Number(n[2])] || `${b[n[2][0]]} ${a[n[2][1]]}`} Lakh ` : '';
  str += n[3] !== '00' ? `${a[Number(n[3])] || `${b[n[3][0]]} ${a[n[3][1]]}`} Thousand ` : '';
  str += n[4] !== '0' ? `${a[Number(n[4])] || `${b[n[4][0]]} ${a[n[4][1]]}`} Hundred ` : '';
  str += n[5] !== '00' ? `${a[Number(n[5])] || `${b[n[5][0]]} ${a[n[5][1]]}`} ` : '';
  return `${str.replace(/\s+/g, ' ').trim()} Rupees Only`;
}

export function moneyValue(...values) {
  for (const value of values) {
    if (value !== null && value !== undefined && value !== '') return Number(value) || 0;
  }
  return 0;
}

export function getTakeHome(payroll) {
  return moneyValue(payroll?.takeHomeSalary, payroll?.netPay, payroll?.netSalary);
}

export function getGrossTotal(payroll) {
  return moneyValue(payroll?.earnTotalGrossSalary, payroll?.totalGrossSalary, payroll?.grossSalary, payroll?.totalCtc);
}

export function getDeductionTotal(payroll) {
  const baseDeduct = moneyValue(payroll?.totalDeductions, payroll?.deductions, payroll?.tax);
  const lopDeduct = moneyValue(payroll?.lop);
  return baseDeduct + lopDeduct;
}

function formatDate(value) {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'N/A';
  return date.toLocaleDateString('en-GB', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric' });
}

function formatAmount(value) {
  const n = Number(value) || 0;
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
  }).format(n);
}

function valueOrBlank(value) {
  return value === null || value === undefined || value === '' ? '' : value;
}

function InfoCell({ label, value }) {
  return (
    <>
      <td className="border border-black px-1.5 py-1 font-normal">{label}</td>
      <td className="border border-black px-1.5 py-1">{valueOrBlank(value)}</td>
    </>
  );
}

export default function PayslipDocument({ payroll, user, monthName }) {
  const periodMonth = monthName || MONTHS[payroll?.month] || '';
  const employeeName = payroll?.employeeName || [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'N/A';
  const employeeId = payroll?.employeeId || payroll?.employeeCode || user?.employeeId || 'N/A';
  const designation = payroll?.designation || user?.jobTitle || 'N/A';
  const takeHome = getTakeHome(payroll);
  const grossTotal = getGrossTotal(payroll);
  const deductionTotal = getDeductionTotal(payroll);
  const basic = moneyValue(payroll?.earnBasic, payroll?.grossBasic, payroll?.basicSalary);
  const hra = moneyValue(payroll?.earnHra, payroll?.grossHra, payroll?.hra);
  const da = moneyValue(payroll?.earnDa, payroll?.grossDa);
  const conveyance = moneyValue(payroll?.earnConvAll, payroll?.grossConvAll, payroll?.transportAllowance);
  const medical = moneyValue(payroll?.earnMedicalAllowance, payroll?.grossMedicalAllowance, payroll?.medicalAllowance);
  const other = moneyValue(payroll?.earnOtherAllowances, payroll?.grossOtherAllowances, payroll?.otherAllowances, payroll?.incentives, payroll?.reimbursements);
  const providentFund = moneyValue(payroll?.pfContribution, payroll?.providentFund);
  const professionalTax = moneyValue(payroll?.professionalTax);
  const incomeTax = moneyValue(payroll?.tds, payroll?.tax);
  const advance = moneyValue(payroll?.advance, payroll?.loanDeduction);
  const otherDeductions = Math.max(0, deductionTotal - providentFund - professionalTax - incomeTax - advance - moneyValue(payroll?.lop));
  const daysInMonth = new Date(Number(payroll?.year) || new Date().getFullYear(), Number(payroll?.month) || 1, 0).getDate();
  const companyName = payroll?.companyName || 'Orakris Med Sol Pvt. Ltd.';

  return (
    <div id="printable-payslip" className="bg-white text-black border border-slate-200 shadow-sm" style={{ fontFamily: 'Arial, sans-serif', width: '760px', minWidth: '760px', margin: '0 auto', padding: '42px 52px 24px' }}>
      <div className="flex items-start justify-between mb-8">
        <img src={logo} alt="Orakris Logo" className="object-contain" style={{ width: '260px', height: '88px' }} />
        <div className="text-[12px] leading-tight mt-2 w-[280px]">
          <div className="font-bold text-[14px]">{companyName}</div>
          <div>{payroll?.address || 'Srivas Pride, 2nd Floor, Chhota Anjaiah Nagar,\nDLF Road, Gachibowli,\nHyderabad - 500032.'}</div>
        </div>
      </div>

      <div className="font-bold text-[14px] mb-10 ml-[55px]">
        Payslip for the month of {periodMonth} {payroll?.year}
      </div>

      <table className="w-full border-collapse text-[11px] leading-tight">
        <colgroup>
          <col style={{ width: '24%' }} />
          <col style={{ width: '24%' }} />
          <col style={{ width: '25%' }} />
          <col style={{ width: '29%' }} />
        </colgroup>
        <tbody>
          <tr>
            <InfoCell label="Employee ID" value={employeeId} />
            <InfoCell label="Date of joining" value={formatDate(payroll?.dateOfJoining || user?.hireDate)} />
          </tr>
          <tr>
            <InfoCell label="Employee Name" value={employeeName} />
            <InfoCell label="Bank Account" value={payroll?.bankAccountNumber || user?.bankAccountNumber} />
          </tr>
          <tr>
            <InfoCell label="Designation" value={designation} />
            <InfoCell label="Bank Name" value={payroll?.bankName || user?.bankName} />
          </tr>
          <tr>
            <InfoCell label="Department" value={payroll?.department || user?.department} />
            <InfoCell label="PAN Number" value={payroll?.panNumber || user?.panNumber} />
          </tr>
          <tr>
            <InfoCell label="Location" value={payroll?.location || payroll?.workLocation || user?.workLocation} />
            <td className="border border-black px-1.5 py-1"></td>
            <td className="border border-black px-1.5 py-1"></td>
          </tr>

          <tr>
            <td colSpan={2} className="border border-black px-1.5 py-2 text-center font-bold">EARNINGS</td>
            <td colSpan={2} className="border border-black px-1.5 py-2 text-center font-bold">DEDUCTIONS</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">Basic</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(basic)}</td>
            <td className="border border-black px-3 py-1.5">Provident Fund</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(providentFund)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">HRA</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(hra)}</td>
            <td className="border border-black px-3 py-1.5">Professional Tax</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(professionalTax)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">DA</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(da)}</td>
            <td className="border border-black px-3 py-1.5">Income tax</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(incomeTax)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">Conveyance</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(conveyance)}</td>
            <td className="border border-black px-3 py-1.5">Advance</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(advance)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">Others</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(other)}</td>
            <td className="border border-black px-3 py-1.5">Other Decrements</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(otherDeductions)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">Medical</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(medical)}</td>
            <td className="border border-black px-3 py-1.5">LOP Deduction</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(payroll?.lop || 0)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5">LTA</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(payroll?.lta)}</td>
            <td className="border border-black px-3 py-1.5"></td>
            <td className="border border-black px-3 py-1.5"></td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-3"></td>
            <td className="border border-black px-3 py-3"></td>
            <td className="border border-black px-3 py-3"></td>
            <td className="border border-black px-3 py-3"></td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5 font-bold">Total Earnings</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(grossTotal)}</td>
            <td className="border border-black px-3 py-1.5 font-bold">Total Deduction</td>
            <td className="border border-black px-3 py-1.5">{formatAmount(deductionTotal)}</td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-1.5 font-bold">Net Salary</td>
            <td colSpan={3} className="border border-black px-3 py-1.5">{formatAmount(takeHome)}</td>
          </tr>
          <tr>
            <td colSpan={4} className="border border-black py-4"></td>
          </tr>
          <tr>
            <td className="border border-black px-1.5 py-1 font-bold">Total Working Days</td>
            <td className="border border-black px-1.5 py-1">{(payroll?.daysPresent ?? payroll?.paidDays ?? daysInMonth) + (payroll?.lopDays || 0)}</td>
            <td className="border border-black px-1.5 py-1 font-bold">LOP days (Loss of Pay)</td>
            <td className="border border-black px-1.5 py-1">{payroll?.lopDays ?? 0}</td>
          </tr>
        </tbody>
      </table>

      <div className="text-center text-[11px] font-bold leading-tight mt-0.5">
        <div>This is a system generated report, does not require any signature.</div>
        <div>Private and Confidential</div>
      </div>
    </div>
  );
}
